import { render, staticRenderFns } from "./bianzheng-result.vue?vue&type=template&id=243ff49d&"
import script from "./bianzheng-result.vue?vue&type=script&lang=ts&"
export * from "./bianzheng-result.vue?vue&type=script&lang=ts&"
import style0 from "./bianzheng-result.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports